function createStation(stationData) {
  return {
    ...{
      additionalInfo: {},
      address: "",
      id: "",
      latitude: 0,
      longitude: 0,
      name: "",
      openingHours: {},
      postcode: "",
      shippingTime: "",
      sort: {
        price: null,
        cart: 0,
        distance: 0,
        expenses: 0,
      },
      suburb: "",
      telephone: "",
      totalCart: "calculating...",
      totalExpenses: "calculating...",
      totalPrice: "calculating...",
      totalShipping: "calculating...",
    },
    ...stationData,
  };
}

export default createStation;
